import axios from "axios";

const Api = axios.create({
    baseURL: "https://scnetwebapilive.azurewebsites.net/api",
    headers: {"Ocp-Apim-Subscription-Key" : "0ee08403ceda45559f612f7a3f1cb22b", "Content-Type": "application/json"}
});

export default Api; 